import { Component } from '@verndale/core';
import TweenLite from 'gsap/TweenLite';
import 'gsap/CSSPlugin';

class Accordion extends Component {
  setupDefaults() {
    this.dom = {
      triggers: Array.from(
        this.el.querySelectorAll('.accordion-item__heading')
      ),
      panels: Array.from(this.el.querySelectorAll('.accordion-item__panel'))
    };
  }

  addListeners() {
    this.dom.triggers.forEach(trigger =>
      trigger.addEventListener('click', ::this.handleTriggerClick)
    );
  }

  closeActiveItem() {
    if (!this.dom.activeItem) {
      return;
    }

    this.closeItem();
  }

  closeItem(item) {
    const trigger = item.querySelector('.accordion-item__heading');
    const panel = item.querySelector('.accordion-item__panel');

    item.dataset.expanded = false;
    trigger.setAttribute('aria-expanded', 'false');
    TweenLite.to(panel, 0.3, { height: 7 });
    setTimeout(() => {
      panel.setAttribute('hidden', true);
    }, 300);
  }

  openItem(item) {
    const trigger = item.querySelector('.accordion-item__heading');
    const panel = item.querySelector('.accordion-item__panel');

    item.dataset.expanded = true;
    trigger.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');

    TweenLite.set(panel, { height: 'auto' });
    TweenLite.from(panel, 0.3, { height: 0 });
  }

  handleTriggerClick(e) {
    const currentTrigger = e.currentTarget;
    const currentItem = currentTrigger.parentNode;
    const expanded = currentTrigger.getAttribute('aria-expanded');
    const isExpanded = expanded === 'true';
    const currentItemInnerContainer = currentTrigger.querySelector('.accordion-item__inner-container');

    if (this.dom.activeItem) {
      this.closeItem(this.dom.activeItem);
    }

    if (isExpanded && this.dom.currentItem !== currentItem) {
      this.closeItem(currentItem);
      this.dom.activeItem = null;
    } else {
      this.openItem(currentItem);
      this.dom.activeItem = currentItem;
    }
  }
}

export default Accordion;
